module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "c05"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ct"
  }, [_c('b', [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('div', {
    staticClass: "cst"
  }, [_c('b', [_vm._v("Key Components of Effective")]), _vm._v(" "), _c('b', [_vm._v("Organizations")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("PART OF THE LARGER CONTEXT FOR THIS WORK")]), _vm._v(" "), _c('div', {
    staticClass: "atx1"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("To know anything well involves a profound sensation of ignorance.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("——JOHN RUSKIN, 1819-1900, ENGLISH CRITIC AND ESSAYIST")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("DEAR READER")]), _vm._v(" For more than three decades, I’ve studied what makes fund development productive and what makes organizations effective. As promised in Chapter 1, I’m describing five components that are of particular value to fund development: organizational development specialists; culture of philanthropy value of research; qualified opinions; and commitment to conservation and questions, learning and change. Together and individually, these five things make a powerful contribution to your organization’s success in fund development.")]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Simone")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "h1"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("ADOPT AN ORGANIZATIONAL DEVELOPMENT APPROACH")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Most fundraising problems are not fundraising problems at all. They are organizational development problems that poison fundraising success."), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#en13",
      "id": "Ref-en13"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" To solve these problems, professionals must become organizational development specialists.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Guaranteed: To survive and flourish, every organization needs its own in-house organizational development specialists. And the fundraising executive should be one of these specialists.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Consider these income-depleting possibilities:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• "), _c('b', [_vm._v("Your organization is blindsided by some event that happens externally or internally.")]), _vm._v(" (What happens, for instance, if your executive director suddenly quits?) How will that event affect your fund development activities and your donors and volunteers? Someone has to raise and own this question. And guess what? That’s you.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• "), _c('b', [_vm._v("There’s major fundraising congestion in your community.")]), _vm._v(" Your organization cannot distinguish itself with a better letter or a more special special event. Instead, you may need to overhaul fund development. You may need to change the way you do the business of your organization, and even what that business is.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• "), _c('b', [_vm._v("Your organization’s mission may be out-of-date and your programs may no longer be important to the community.")]), _vm._v(" Eventually your stakeholders/constituents will notice and leave. Your donors will stop giving.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• "), _c('b', [_vm._v("Your donors may not feel close enough to your organization.")]), _vm._v(" Small gifts will not become larger ones, and donors may not renew their gifts.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Finally, fund development has never been solely about money. It’s always been about relationships. And that means understanding someone’s interests and finding a match with your organization. Or accepting people’s disinterest and moving on. Simply focusing on dollar goals, response rates, and prospect research won’t work without forging a deep relationship between the organization and the prospect.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("None of these situations is new. They were true yesterday and will be true tomorrow. The only difference may be the speed and frequency with which these situations occur, the time and effort it takes to recover, and the increasing frustration experienced by donors, volunteers, clients, and staff.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Limitations of Technical Fundraising")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Technical fundraisers abound. They focus almost exclusively on how-tos and on managing tactics to produce more money. These technicians are good at isolating a fundraising challenge or opportunity and devising an appropriate response. Every fund development team needs great technicians. And all fundraisers need to stay up-to-date on the latest how-tos and tactics.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("But being a technician is not enough. It never has been. Since most fundraising challenges stem from the organization and its operations, not from fund development, you must be able to discern the true nature of the situation in order to solve it. Focusing on fund development, as technicians do, doesn’t solve the nonfund development problems. Healthy charitable gifts income is a by-product of doing lots of things other than fund development well.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Whereas fundraising technicians can, and often do, succeed, remaining merely a technician leaves you and your organization vulnerable.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("You can always find a great technician. But organizational development demands broader learning and a commitment to leadership beyond fund development.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Turning You into an Organizational Development Specialist")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Organizational development specialists garner respect and access throughout the organization, probing deeply into areas that ordinary fundraising technicians would consider out of bounds. These areas include board recruitment and performance expectations, organization-wide planning and community needs assessment, program quality and customer service, mission drift and communications, and more.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Organizational development specialists are change agents. They are critical thinkers; they analyze, they critique, and they work out solution with others. These professionals ask the tough questions about fund development and every other area of operation. They track down challenges and opportunities facing the organization. These leaders observe how things link across the organization and then figure out how to suggest and facilitate change.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Are you in charge of hiring a fund development executive, either staff or consultant? Make sure you pick an organizational development specialist.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("As strategists, organizational development specialists help the organization decide where it wants to go and how to get there. They identify relevant information and help others understand the implications of the information.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("These accomplished fundraisers are often the first to question whether the organization is still relevant to the community, because irrevelance cramps the ability to build donor loyalty and raise money. But it’s more than a financial  question; it’s an ethical question. Organizational development specialists know that without sufficient relevancy, an organization has no right to exist and drain community resources.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("As pivotal players in the agency, these accomplished individuals are consummate enablers, empowering volunteers and staff to participate meaningfully on behalf of the organization. See Appendix A for a brief overview of enabling. For further detail, see my book "), _c('i', [_vm._v("Strategic Fund Development: Building Profitable Relationships That Last.")]), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#en14",
      "id": "Ref-en14"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("What the Organizational Development Specialist Needs to Know")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Take a look at my list. You don’t have to be an expert in all the areas, but you have to be pretty darn knowledgeable. And some of this will be familiar to you if you check out the CFRE test content outline, the baseline certification for fundraisers worldwide.")]), _vm._v(" "), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• General business management and governance")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Group dynamics and organizational behavior")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Learning organization and systems thinking theories")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Strategic and operational planning")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Fiscal planning and management")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Volunteer and staff role delineation and performance appraisal")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Marketing and communications")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Values clarification and mission and vision")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Enabling")])]), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Skills of organizational development specialists include:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Conflict resolution and facilitation")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Critical and strategic thinking")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Proficient teacher and learner")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Effective communicator and motivator")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("For more details about organizational development specialists, visit the Free Library (located in the Resources section) on my Web site at "), _c('a', {
    attrs: {
      "href": "http://www.simonejoyaux.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonejoyaux.com")]), _vm._v(". For help making all this theory work, see "), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#EXH-3.1-section-1-11-1-3",
      "id": "Ref-EXH-3.1-section-1-11-1-3"
    }
  }, [_vm._v("Exhibit 3.1")]), _vm._v(". Also see "), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#EXH-3.2-section-1-11-2-1",
      "id": "Ref-EXH-3.2-section-1-11-2-1"
    }
  }, [_vm._v("Exhibit 3.2")]), _vm._v(", tips about your fund development committee meeting, which can help make theory practical.")]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-EXH-3.1-section-1-11-1-3",
      "id": "EXH-3.1-section-1-11-1-3"
    }
  }, [_c('b', [_vm._v("EXHIBIT 3.1")])]), _vm._v(" "), _c('b', [_vm._v("HELPING YOUR ORGANIZATION IMPLEMENT THEORIES AND IDEAS")])]), _vm._v(" "), _c('div', {
    staticClass: "centerAligned"
  }, [_c('div', {
    staticClass: "centerAligned"
  }, [_c('table', {
    staticClass: "b"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Much of the information and many of the ideas in this book are not new. You may know all or lots of this. In that case, the repetition affirms that you are on a good track. Or the repetition stimulates a new insight for your own application.")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Often the challenge is implementation. Not conceiving the idea but actually translating it into action and making it work.")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Professionals—especially organizational development specialists—enable others to do the work. These leaders explain the why behind the how-to. These professionals translate ideas into action. They give practical, tangible examples so others understand.")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("I call this “operationalizing” the idea or the concept. (You can only imagine how disgusted Tom was with that word! But hey, what other word would you pick? How about “making an idea tangible”? Then the verb would be even more awkward, “to tangibilize”! Anyway, “operationalize” is actually a term in science.)")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Think about all those directions that accompany various products. You know, assembly required! Now imagine those directions without any illustrations (I got that from The Big Moo. Pretty neat, eh?) That’s your job. You operationalize for others through your explanations and examples. You enable staff, board members, and other volunteers to operationalize.")])]), _c('tr', [_c('td', {
    staticClass: "b x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("And finally, you help your organization institutionalize these new ways of thinking and acting. The term “institutionalizing” means to make something a custom, an accepted part of the organization’s structure, systems, and practice.")])])])])]), _c('div', [_c('a', {
    attrs: {
      "id": "h2"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("BUILD A CULTURE OF PHILANTHROPY")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Concept of Corporate Culture")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Research finds that the so-called culture inside an organization dramatically impacts its effectiveness. This includes for-profit and nonprofit corporations and government entities.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("What does “culture” mean? Generally speaking, the term “culture” refers to the particular attitudes, beliefs, customs, practices, and social behaviors that characterize a group of people.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("What does the term mean when referring to an organization or group? The same thing. A strong culture exists when people within the organization share values. This alignment allows them to work together, share experiences, and move forward. A weak culture results when there is little alignment of values. In such organizations, control typically is enforced through bureaucracy, systems, and rules.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("All groups, large and small, develop a culture. Culture is pervasive. It impacts all areas of the organization including fund development effectiveness and results.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Of course, organizational culture can be either positive or negative, or somewhere in between. You’ve seen toxic organizations and so have I. And I’ve also  seen strong cultures that perpetuate negativity. The people in those organizations aren’t happy or supportive. These aren’t good places to work or volunteer.")]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-EXH-3.2-section-1-11-2-1",
      "id": "EXH-3.2-section-1-11-2-1"
    }
  }, [_c('b', [_vm._v("EXHIBIT 3.2")])]), _vm._v(" "), _c('b', [_vm._v("ASK THESE QUESTIONS AT THE END OF EVERY FUND DEVELOPMENT COMMITTEE MEETING")])]), _vm._v(" "), _c('div', {
    staticClass: "centerAligned"
  }, [_c('div', {
    staticClass: "centerAligned"
  }, [_c('table', {
    staticClass: "b"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_vm._v("Ask these three questions at the end of every fund development committee meeting (or for that matter, any committee):")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("1.")]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What information—translated into trends and implications—needs to be shared with the board, and why?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("2.")]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What trends and implications require strategic dialogue with the board—or with different individuals and groups within the organization—and why? What background information—and strategic questions—should be provided in advance to prepare for the strategic dialogue? How will you facilitate the dialogue?")])]), _c('tr', [_c('td', {
    staticClass: "b x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("3.")]), _c('td', {
    staticClass: "b x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What decisions need to be made by which individuals or groups within the organization? What kind of information and questions must be provided in advance, to set the context for the decision-making dialogue?")])])])])]), _c('div', {
    staticClass: "tx"
  }, [_vm._v("In this book, we focus on strong organizations that perpetuate a positive culture. These organizations carefully define and nurture the kind of culture that builds effective and more productive organizations.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("For me, a culture of philanthropy is an essential component of a positive corporate culture in the nonprofit/NGO sector. In my experience, professionals and organizations that nurture a culture of philanthropy are more likely to succeed.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Everything else can fall away; the industry and products and circumstances may change; but an abiding culture can serve as the custodian of dreams for your company team, and for the customers on whose faith you build your house of business. It is an unchanging constant in the midst of a tornado of change, and it is something people want badly. It allows us to offer choice to those who work here and for those we want to work here... to live and work by their values, and who will toil together toward something larger than themselves. . . . The company, at its best, can be a vehicle for everyone to make a difference.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—DAVID S. POTTRUCK AND TERRY PEARCE, "), _c('i', [_vm._v("CLICKS AND MORTAR")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Culture of Philanthropy")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("More and more fundraisers talk about a culture of philanthropy. Just Google the term! I first started writing about a culture of philanthropy in the late 1990s, and focused on it in the second edition of "), _c('i', [_vm._v("Strategic Fund Development.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("But what, exactly, is this culture of philanthropy? Like any culture, it’s that generally unconscious personality of your organization. It’s a feeling that infiltrates everyone and everything in your organization.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("I think a culture of philanthropy looks like this: Everyone in the organization accepts and celebrates these points:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Philanthropy means giving time and/or money.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• A philanthropist is anyone who gives time and/or money, regardless of the amount.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Philanthropy is not merely a means to carry out the organization’s mission. Instead, everyone embraces philanthropy as an essential component of civic engagement and healthy community.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("The culture of philanthropy is the perfect blending of philanthropy and fund development—and only the positive words and feelings echo forth. The philanthropic culture embraces the two sides of the coin, donor-centrism and donor loyalty. This culture embodies the virtuous circle of relationships.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("In my ideal culture of philanthropy, people in the organization break the obsession with transactions and mechanics and learn to cherish interests and emotions. Organization representatives reach out to stakeholders, describing the value of giving. Each person in the organization serves as an ambassador promoting both the organization’s mission and the concept of philanthropy. Each person honors all donors—whether of time or money, no matter the amount—as central figures in the organization’s mission.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Remember “Beginning at the Beginning,” that larger context and philosophical framework for philanthropy ad fund development? Our work is about building community, creating civil society, and nurturing civic capacity. How can we do that without believing in and living a culture of philanthropy?")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("And by the way, to achieve maximum donor revenue and sustain that maximum indefinitely, nonprofits/NGOs depend upon a strong culture of philanthropy. Effective leaders of these organizations help define and then consciously nurture this culture.")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("Meaningful Questions")]), _vm._v(" This book is about one thing above all: asking lots of questions. As you think about organizational culture and a culture of philanthropy, take a look at the questions proposed here.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("But before you review the questions, think about this: How will you even get your colleagues to talk about the most meaningful questions? Try these tips:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• If you’re the executive director, introduce the topic of corporate culture at your next staff meeting. Talk a bit about it. Let people share examples. And at the next staff meeting, begin discussing these questions.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• If you’re not the executive director, take him or her to lunch and introduce the topic of corporate culture. Talk about how the staff—and even the board—could have this kind of discussion.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Now begin working on these eight questions in your organization. How would you answer these questions where you work or volunteer? How do you think your colleagues would respond?")]), _vm._v(" "), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("1. How would you describe your organization’s culture, its personality? How does it feel to work there?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("2. How does this culture affect your enthusiasm and commitment, and your behaviors and interactions?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("3. How do you think your colleagues define the organization’s culture? How do you think their perception affect the work environment? (You actually have to ask colleagues these questions, not just trust your judgment about what they think.)")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("4. What kind of process would help your organization examine and evaluate its organizational culture, define any desired changes, and then make the change?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("5. How would a culture of philanthropy look and feel to your staff colleagues, your donors, and your volunteers?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("6. How would you nurture this culture of philanthropy in your organization?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("7. How would you distinguish a culture of philanthropy from a culture of giving?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("8. How is a culture of philanthropy different from a culture of greed?")]), _c('div', {
    staticClass: "tx"
  }, [_vm._v("After a session with me in January 2005, the AFP Southern Minnesota Chapter developed seven culture-defining questions to ask internally:"), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("1. Is building a culture of philanthropy any different from building a culture of excellence?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("2. How do we engage linear thinkers in culture building, because they don’t always value process? (Linear thinking proceeds in an obvious sequential manner, without in-depth understanding.)")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("3. How well do we understand ourselves and our own motivations for giving?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("4. How does a culture of philanthropy apply to soliciting low-income clients, and who makes these decisions?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("5. Do we have the courage to treat everyone the same? Do we treat our donors better than our clients? Do we treat all donors the same?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("6. How can we ease people’s fears, anxieties, and discomforts about money (e.g., board member discomfort about solicitation; donor discomfort about the size of their gifts)?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("7. How do employment practices impact a culture of philanthropy?")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "h3"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("PERSONAL AND ORGANIZATIONAL COMMITMENT TO CONVERSATION AND QUESTIONING, LEARNING AND CHANGE")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("“Conversation,” “questioning,” “learning,” and “change” are familiar words.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("But in business theory, these terms take on special urgency because they are all recognized now as secrets behind organizational success. Of course, merely giving lip service to these high-powered concepts achieves nothing. It’s past time for fundraisers and their organizations to make these concepts a core part of their professional behavior. And it might be left to you as the organizational development specialist to help your agency incorporate these concepts as an established part of operations.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Learning Organization Theory")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("According to the experts like learning organization guru Peter Senge, learning means building the capacity of an organization and its individuals to achieve results. Learning is more than acquiring information; it’s about re-creating yourself. This requires new ways of thinking, and often, as Yoda, the Jedi character in George Lucas’s "), _c('i', [_vm._v("Star Wars")]), _vm._v(" films, says: “You have to unlearn what you’ve learned.”")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Senge uses the word “metanoia,” which means shift of mind, to describe the learning organization. “To grasp the meaning of ‘metanoia’ is to grasp the deeper meaning of ‘learning,’ for learning also involves a fundamental shift or movement of mind.”"), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#en15",
      "id": "Ref-en15"
    }
  }, [_c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("The attributes of entrepreneurship—risk taking, innovation, vision—are both cultural and learned.")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—GROUP OF 33, "), _c('i', [_vm._v("THE BIG MOO")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Learning is a prerequisite to change. Change is a fact of existence. So ultimately, your organization’s effectiveness and results depend on how fast, how well you learn and change.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Film director, producer, and screenwriter Francis Ford Coppola was "), _c('i', [_vm._v("not")]), _vm._v(" working in a learning organization environment when he said, “I’ve found in dealing with people, with society, that you barely get an idea out into the room before there are four or five reasons why it should be killed. Sometimes good  reasons, sometimes not. Nonetheless, if you kill off an idea too early, then you never get to places you would have gotten to.”"), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#en16",
      "id": "Ref-en16"
    }
  }, [_c('sup', [_vm._v("4")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-EXH-3.3-section-1-11-3-1",
      "id": "EXH-3.3-section-1-11-3-1"
    }
  }, [_c('b', [_vm._v("EXHIBIT 3.3")])]), _vm._v(" "), _c('b', [_vm._v("AIM FOR A MIND SHIFT, YOUR OWN METANOIA")])]), _vm._v(" "), _c('div', {
    staticClass: "centerAligned"
  }, [_c('div', {
    staticClass: "centerAligned"
  }, [_c('table', {
    staticClass: "b"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_vm._v("How to start? Try Einstein’s approach: “I have no special talents. I am only passionately curious.” But how can you develop your curiosity? How can you stimulate new thinking in your organization?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Here’s some inspiration from "), _c('i', [_vm._v("The Big Moo")]), _vm._v(":")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("“[G]et as serious, rigorous, and creative about renewing yourself as any other aspect of your business. So get out. Get out of your comfort zone...we preserve and revere experience when we should be challenging and renewing it . . . invite naïveté, passion, and new talent into the organization . . . Pick up a new tool . . . Try something you’ve never done before . . . without judgment. Get out of your frame of reference. The best way to open your mind is to apply a jolt of unfamiliarity . . . seek out new sources, mix up your milieus, and rearrange your references. Go on a field trip. Go somewhere you’ve never been before . . . Think contrast... Let your questions lead . . . Get out of your own skin . . . stir up your passions, dreams, and projects lying dormant inside yourself... ”")])]), _c('tr', [_c('td', {
    staticClass: "b x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "b x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Group of 33, "), _c('i', [_vm._v("The Big Moo: Stop Trying to Be Perfect and Start Being Remarkable")]), _vm._v(", ed. Seth Godin, New York: Portfolio (Penguin Group) 2005")])])])])]), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Clearly Coppola expects to experiment and welcomes the risk and potential reward. He knows that creating something new involves risk and requires courage. I imagine Coppola applauding Irish novelist and playwright Samuel Beckett, who said, “No matter. Try again. Fail again. Fail better.” I suspect that those who accept learning organization theory see mistakes as Joyce’s “portals of discovery.”")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Now it’s up to you. Create your own mind shift or new viewing lens (see "), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#EXH-3.3-section-1-11-3-1",
      "id": "Ref-EXH-3.3-section-1-11-3-1"
    }
  }, [_vm._v("Exhibit 3.3")]), _vm._v(").")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Systems Thinking, the Cornerstone of Learning Organizations")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Here’s a mini-primer. An organization, like your own body, operates as a single system. What happens in one part of the system affects other parts of the system, either sooner or later.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Systems thinking means you see the whole: your entire organization and all its departments and activities. You understand how the individual parts relate and operate for a common purpose. You know that what happens in one part of the system (e.g., your organization) affects what happens elsewhere in the system, maybe not immediately, but certainly eventually. For example, program quality and board recruitment affect fund development, values affect board and staff recruitment, and so forth. The systems thinking approach helps you figure out the best place you can push or manipulate in complex situations. Think of these places as leverage points to produce learning and make change.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Conversation at Work")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("According to dictionaries, “conversation” is the informal way that we exchange opinions, ideas, and feelings. Obviously individuals do this. As social beings, humans connect through conversation.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("But in learning organization theory, conversation is a core business practice as well. Widely-respected business journalist Alan Webber says conversations are the way that workers “discover what they know, share it with their colleagues, and in the process create new knowledge for the organization. The panoply of modern information and communication technologies . . . can help knowledge workers in this process. But all depends on the quality of the conversations that such technologies support.”"), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#en17",
      "id": "Ref-en17"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" Learning organizations use conversation (also called dialogue) and questioning to stimulate learning and change.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("In both personal and business realms, conversation circulates information and nurtures relationships. Conversation helps generate commitment, thus producing a sense of community. And this feeling of community is characteristic of highly functioning organizations. Think about those Three Musketeers, “all for one and one for all.” Now that’s commitment!")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("It is in how we speak with one another that we experience respect from others and [know] whether we are being heard.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—LINDA ELLINOR AND GLENNA GERARD, "), _c('i', [_vm._v("DIALOGUE: REDISCOVER THE TRANSFORMING POWER OF CONVERSATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("As a core business practice, the informal conversation around the photocopier can help individuals understand why donor recognition is important. Maybe in a lunchroom a colleague talks about how she was recognized as a donor to her mosque and suddenly a wonderful new idea for donor recognition pops into your head. Conversations with clients offer important insights to improve your service quality.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("The most effective organizations actively promote conversation in order to optimize learning and change. See the tips in "), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#EXH-3.4-section-1-11-3-3",
      "id": "Ref-EXH-3.4-section-1-11-3-3"
    }
  }, [_vm._v("Exhibit 3.4")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Conversation produces individual and organizational learning by:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Gathering information and identifying trends")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Interpreting the implications of the information")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Identifying possible choices and the consequences of those choices")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Sharing knowledge")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Questioning assumptions")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Identifying conflict and commonalities")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Generating ideas "), _c('div', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-EXH-3.4-section-1-11-3-3",
      "id": "EXH-3.4-section-1-11-3-3"
    }
  }, [_c('b', [_vm._v("EXHIBIT 3.4")])]), _vm._v(" "), _c('b', [_vm._v("HOW TO PROMOTE MORE CONVERSATIONS IN YOUR ORGANIZATION")])]), _vm._v(" "), _c('div', {
    staticClass: "centerAligned"
  }, [_c('div', {
    staticClass: "centerAligned"
  }, [_c('table', {
    staticClass: "b"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_vm._v("Examine the conversations in your organization. How does your organization use conversation as a core business practice? Do you see lots of conversations, both formal and information, structured and casual? Explore the questions below. How would you modify them for your organization? What would you add?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("•")]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Where do the best conversations happen in your organization—and why?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("•")]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What do your board and committees talk about, and why?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("•")]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("How do your conversations extend between departments and across areas of operation?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("•")]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("How do you ensure that your conversations are inclusive, welcoming diverse people and perspectives?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("•")]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("How do your conversations encourage questioning and stimulate innovation?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("•")]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("How do you use information to stimulate questioning and expand conversation?")])]), _c('tr', [_c('td', {
    staticClass: "b x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("•")]), _c('td', {
    staticClass: "b x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What changes must happen—and why—to nurture conversation in your organization?")])])])])])]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Creating shared meaning")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Building understanding and ownership and alignment")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Supporting change")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Creating a sense of community and shared purpose")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Asking the Essential Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Now think about conversation and asking questions. Usually you start a conversation, and continue it, with a question. You learn by asking a question. You stimulate thinking—your own and that of others—with questions. You help people reflect on their own assumptions by questioning them yourself. And you expect others to help you think by questioning your assumptions.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_vm._v("Pursuit of knowledge is based on asking questions, questioning answers, and asking the right questions in the first place.")]), _vm._v(" "), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—KARLA A. WILLIAMS ACFRE AND SIMONE P. JOYAUX ACFRE")])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("How does this work?")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("An important question makes you pause. You question your own assumptions. This can be difficult. After all, personal assumptions are based on life experience and knowledge. These assumptions often define us. Yet questioning one’s own assumptions and the assumptions of others is essential to stimulate learning and change, thus helping to build an effective organization.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Asking meaningful questions is not a rhetorical exercise, where the questioner is attempting to make a point. Nor is it an attempt at sabotage or a test. Instead, the best questioning is stubbornly open-ended. It promotes conversation, learning, innovation, and change. And the truly essential questions take you to a new place entirely.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("A good question is never answered. It is not a bolt to be tightened into place but a seed to be planted and to bear more seed toward the hope of greening the landscape of the idea.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—JOHN CIARDI, QUOTED IN "), _c('i', [_vm._v("75 CAGE-RATTLING QUESTIONS TO CHANGE THE WAY YOU WORK")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("However, questions can be risky. Some of the best questions cause conflict and discomfort. But that’s good! In a board meeting, Alfred Sloan, a former CEO of General Motors Corporation, supposedly said about an important decision: “I take it that everyone is in basic agreement about this decision?” When everyone nodded yes, Sloan replied, “Then I suggest we postpone the decision. Until we have some disagreement, we don’t understand the problem.”")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Handled well, the conflict and discomfort of great questions stimulates conversation and encourages deeper thinking. Sadly, too many organizations suffer from dysfunctional politeness. Avoiding disagreement and discomfort, though, is a real quick way to disempower your board, pacify your staff, stifle innovation, and—bottom line—ruin your organization. Yes, "), _c('i', [_vm._v("ruin")]), _vm._v(" your organization. Dysfunctional politeness stops you from talking about the difficult issues. Avoiding unpleasant questions and conversations is a bad and unhealthy habit. Eventually it will ruin your organization, rest assured.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("The best way to strengthen your organization is getting people to ask the “why” questions and working hard to answer them.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("The Best Questions Rattle the Most Cages")]), _vm._v(" What do you think are the most important questions your organization should discuss? What are the most difficult questions your organization must confront? These are your “cage-rattling questions,” a phrase borrowed from authors Dick Whitney and Melissa Giovagnoli in their book "), _c('i', [_vm._v("75 Cage-Rattling Questions to Change the Way You Work")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#en18",
      "id": "Ref-en18"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" This book can help craft questions for you and your organization. Here are some of my favorites. How would you modify them for your organization?")]), _vm._v(" "), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• “Pretend your organization (or department) is an organized religion. What are the core beliefs? What constitutes a sin?” (From Simone: Think organizational values.)")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• “What drives your best customers crazy and what makes them exceedingly happy?” (From Simone: Think donors and volunteers and those you serve.)")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• “If your crystal ball told you that most of the products or services you work with will be obsolete in five years, how would you react?” (From Simone: Think strategic planning and the process to define your organization’s relevance.)")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• “If you came up with a brilliant idea, who or what might prevent you from implementing it?” (From Simone: Think organizational development.)")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• “If you could snap your fingers and turn your boss into a member of the opposite sex (or another race, or change his or her age by 30 years), what workplace issues might he or she become more sensitive to? (From Simone: Think about diversity and cultural competence.)")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• “Top management is wiped out by a tidal wave at their annual retreat in Bora Bora; when your team is put in charge of the company, how would you change things and who would be in charge?” (From Simone: Wow.)")])]), _c('div', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("Composing Good Questions, Whether Business or Personal")]), _vm._v(" Composing good questions is hard work. Good questions focus on the important issues, not the inconsequential ones. Good questions are open enough to kindle thinking and useful conversation.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Use these tips to help develop good questions:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• "), _c('b', [_vm._v("Avoid questions with yes/no answers.")]), _vm._v(" They shut down thinking and stop conversation.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• "), _c('b', [_vm._v("Create open-ended questions.")]), _vm._v(" They stimulate thinking and produce more conversation.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• "), _c('b', [_vm._v("Focus on strategic issues with significant implications.")]), _vm._v(" Don’t waste people’s time with frivolous questions that don’t really matter.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• "), _c('b', [_vm._v("Remove bias in your questions.")]), _vm._v(" Make sure your own assumptions are not embedded.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• "), _c('b', [_vm._v("Aim for simplicity.")]), _vm._v(" Overly complex questions distract people.")])])]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("What assumptions are you making that stop you from changing?")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("This book includes lots of strategic questions—questions intended to surprise, cause discomfort, stimulate novel thinking, and reinforce risk taking. You’ll find more questions (including questions about boards, philanthropy and fund development, and volunteerism) in my book "), _c('i', [_vm._v("Strategic Fund Development")]), _vm._v(" and at "), _c('a', {
    attrs: {
      "href": "http://www.simonejoyaux.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonejoyaux.com")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("For example:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• How will you help your board members overcome their discomfort with fund development?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• How can you create meaningful relationships with your donors?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• How can you value all donors regardless of gift size?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• And here’s a cage-rattler: If your mission is no longer relevant, how should your organization change?")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Chapter 17 focuses on conversations with your prospects and donors and includes lots of questions for these conversations.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("This Is Hard Work")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("The theories of conversation and questioning, learning and change are often threatening. In my experience, this approach requires a certain comfort with complexity, disagreement, and conflict. There are lots of whys and then "), _c('i', [_vm._v("more")]), _vm._v(" whys. Things don’t always proceed sequentially, in an obvious linear manner. And all this is accompanied by hassles and anxiety. And rest assured, Tom and I feel the hassles and anxiety too!")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Sometimes it’s hard to identify the questions that matter the most. And it’s even harder to risk the asking. It’s also difficult to design questions that take you or your organization to a really new place.")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "h4"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("VALUE OF RESEARCH—YOUR OWN AND THAT OF OTHERS")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Research is as close as the real world comes to owning a crystal ball. You ignore research at your organization’s peril.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Where were you, for instance, the day direct mailed died? That’s an exaggeration, of course. It’s not dead yet. But it is in flux, as you know if you keep up with the research. Given that flux, what are your plans for direct mail?")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Where were you when women inherited the money and controlled gift giving? That one’s old news, eh? But have you adjusted your relationship building and solicitation according to the research?")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Just imagine if you missed either of those announcements. And imagine what other useful insights you miss unless you follow the research.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("The bottom line: Quality information helps make quality decisions. The right information is essential to getting the job done well. Equally important, the right information produces questioning, learning, and change. Indeed, information, question, and conversation are interdependent.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Research replaces assumptions, which often lead you astray. Research can countermand the personal opinions of others. Research helps you anticipate and  avoid problems. When analyzed and interpreted, research data explain the why and justifies the how-to.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Accomplished professionals seek opportunities for information. These professionals follow news reports about research, go to the original source, and read the details. These professionals seek research sessions at conferences.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("The farmer who has never ventured beyond his field says his own methods are the best.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—POPULAR SAYING FROM THE ANLO-EWE TRIBAL GROUP OF GHANA")])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("By the way: Don’t be country-centric in your examination of research. If you’re from the United States, you should know that some of the best research is being done elsewhere. Visit major Web sites in other countries to find out what’s going on elsewhere. See examples at "), _c('a', {
    attrs: {
      "href": "http://www.simonejoyaux.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonejoyaux.com")]), _vm._v(". Ask colleagues. Search the Internet. How would you answer the questions in "), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#EXH-3.5-section-1-11-4",
      "id": "Ref-EXH-3.5-section-1-11-4"
    }
  }, [_vm._v("Exhibit 3.5")]), _vm._v("?")]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-EXH-3.5-section-1-11-4",
      "id": "EXH-3.5-section-1-11-4"
    }
  }, [_c('b', [_vm._v("EXHIBIT 3.5")])]), _vm._v(" "), _c('b', [_vm._v("HOW WOULD YOU AND YOUR ORGANIZATION ANSWER THESE QUESTIONS?")])]), _vm._v(" "), _c('div', {
    staticClass: "centerAligned"
  }, [_c('div', {
    staticClass: "centerAligned"
  }, [_c('table', {
    staticClass: "b"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Are you passionate about philanthropy and fund development, not just your organization’s mission?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Are you passionate about the whys, not just the how-tos?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("3.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Why is best practice best practice?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("4.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Which best practice is appropriate for your organization now?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("5.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What preparation must you do with your organization before it is ready to confront some parts of best practice?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("6.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("How will you customize best practice for your organization?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("7.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What knowledge and skills are necessary for you and your organization to carry out best practice? What should reside within you and your organization? What already resides within you and your organization? How will you acquire what you do not yet have?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("8.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What’s the difference between a right and a wrong decision, and a preferred decision for this time in your organization?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("9.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What can be outsourced without compromising that which you and your organization should know?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("10.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("How will you explain all this to your organization?")])]), _c('tr', [_c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("11.")])]), _c('td', {
    staticClass: "x x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What modifications of best practice would you propose for the sector, and why?")])]), _c('tr', [_c('td', {
    staticClass: "b x ",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("12.")])]), _c('td', {
    staticClass: "b x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("What do you anticipate as next practice for the sector, and why?")])])])])]), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Collecting Data from Your Organization")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("The best fundraisers also collect meaningful data within their own organizations. What data does your organization currently collect, and what is the data good for? Consider these eight questions:"), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("1. What information do you gather internally about your own strategies, tactics, and results? What information do you gather from comparable organizations that might prove helpful?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("2. How do you analyze and present trends as objectively as possible, but with the added value of your expertise?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("3. How do you present information in a way that opens rather than ends conversation?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("4. What data are available in the philanthropic sector that can help assess and inform your organization?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("5. What societal information would be useful in your deliberations—for example, economic, regulatory, lifestyle, workplace, demographics, and so on?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("6. What questions arise as you analyze and interpret the trends through various lens: for example, gender and sexual orientation, age and ethnicity/ race, socioeconomics, and so on?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("7. How will you facilitate strategic dialogue about the implications of these trends?")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("8. How will you enable your organization to make the best decisions regarding strategies and tactics?")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Translating Data into Useful Information")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("The best fundraisers know that information is useless without an analysis of the trends and implications, followed by strategic conversation about the meanings and consequences. Unfortunately, too much information is presented without analysis and void of strategic conversation.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Data itself is nothing unless one uses it as a resource from which to draw conclusions.")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—BRIAN HERBERT AND KEVIN J. ANDERSON, "), _c('i', [_vm._v("DUNE: THE MACHINE CRUSADE")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("A caveat: Beware about jumping to conclusions. Evaluate and interpret data through diverse lens and multiple areas of expertise. See Chapter 24 for more about translating data into useful information.")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "h5"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("QUALIFIED OPINIONS ONLY, PLEASE!")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Depend on the documented body of knowledge and research, not a single person’s opinion. Read publications. Attend workshops. Apply the lessons learned. Ask questions and question assumptions. With all this, you will understand the “why” behind each how-to. Then you have the knowledge and experience to question current practice. And with your own experience and learning, you can propose and anticipate next practice.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Seems sensible, eh? Yet how often do you hear someone’s opinion—stated with great assurance—that contradicts the body of knowledge? How often do you try to explain why someone’s personal opinion actually conflicts with best practice and is problematic rather than helpful?")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("For example:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Your wonderful volunteer offers the opinion that direct mail is better than a face-to-face request. But you know that face-to-face solicitation is estimated to be many times more effective than direct mail. You suspect the volunteer’s opinion is based on personal discomfort. But the board credits the opinion and wastes time discussing the comparative value of solicitation strategies rather than talking about how to develop its capacity to do face-to-face solicitation.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Perhaps a great graphic designer has just re-created your newsletter. You’re thrilled with how good it looks. Then you find out that the design reduced readability by 500%.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Or the marketing/public relations department in your university keeps writing bad headlines and poor photo captions. You explain the body of knowledge and you’re told that’s “just your opinion.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Opinion just got you into trouble. The volunteer doesn’t know the body of knowledge for fund development. The graphic designer isn’t familiar with readability standards. And your marketing/public relations staff don’t understand written communications.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("A Curious Conundrum")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("We face a curious conundrum in the philanthropic sector. We engage volunteers. We enable them to help raise charitable gifts. And suddenly some of those volunteers assume that their opinion is equal to the documented body of knowledge.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("We hire well-trained graphic designers who create really pretty materials. But these professionals never learned the science of readability—and some don’t want to learn it. So their design frustrates easy reading and people don’t read your publications—but they all think your stuff is pretty.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Curiously, no one would dare tell a builder that the short nails are cuter so “let’s use them instead of the long ones.” No one but another experienced surgeon would discuss which scalpel to use in brain surgery. And the electrician generally gets more respect than the fundraiser!")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Opinions can be big trouble. How valuable is someone’s view when it is based solely on personal judgment rather than an understanding of the body of knowledge and experience? How valuable is someone’s technical opinion without a solid understanding of the myriad intersecting whys?")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Personal opinions about personal issues are fine. But opinions about business issues—which are not qualified through sufficient technical expertise coupled with an understanding of why—are baseless and useless, and often cause problems.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("However, keep in mind this special warning: Asking strategic questions and questioning assumptions is different from offering an opinion. Everyone has the right to ask questions and question assumptions, whether his or hers or those of others. So here’s the bottom line: Encourage questioning and discourage unqualified opinions.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Learning is a paradox. It is life affirming and often painful, because you care, and without it you’re literally dead.")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—GROUP OF 33, "), _c('i', [_vm._v("THE BIG MOO")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Corollary of the Curious Conundrum")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Or, as Tom asked in his February 2007 e-news, “Who’s blessing YOUR stuff?")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Who approves your solicitation letters or your written case statement or your newsletters? Absolutely NOT NOT NOT your board of directors or your fund development committee or your board chair or your committee chair, or any other volunteer that I can think of.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("This is staff work—whether you write it yourself or hire an expert to write it; whether you design it in house or hire designers. This work is not board work.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("The problem isn’t whether the board or board member liked the four-page letter or not. The problem is scope of authority and who does what. Fix that problem first. Distinguish between staff work and board work, typically described as management and governance. Define the limits of authority between management and governance. That’s the real problem to solve.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Now, if your board chair complains after receiving the solicitation letter, saying “I throw away such long letters,” then quote best practice. Show the body of knowledge. Explain the research. But most important, graciously say, “I’m the expert, that’s why I was hired. I know the body of knowledge and best practice. I read the books and the research. You can count on me to do my job correctly.”")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Staff members are supposed to be the in-house authorities on all things within the management purview. They should know what they’re doing, or they hire that expertise, or they have on hand expert books that demonstrate how to do things the right way. As Tom notes, “I can’t think of any topic in fund development or advocacy communications that can’t claim a book written by a credible expert.” (And by the way, that goes for everything else in management too.)")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Instincts just aren’t enough, and nonprofessionals use the wrong criteria. (Car manufacturer Henry Ford once said, “If we’d asked the public what they wanted, they would have said ‘a faster horse.”’)")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Combine the curious conundrum of unfounded opinions and its corollary, inappropriate authority, and here’s the summary: It’s irresponsible to cede authority to those who do not actually have the authority. It’s irresponsible to cede expertise and experience to uninformed opinions and second-guessing. Without malice or intent, this inappropriate input can easily ruin competent work and undermine your ability to nurture relationships and raise charitable gifts. When untrained and illinformed people have the final say on what goes out the door, you run a serious risk.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("When love and skill work together, expect a masterpiece.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—JOHN RUSKIN")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "h6"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("IN CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Accomplished professionals position themselves as reliable experts and resources, competent teachers, and trusted advisors. These professionals hold organizations and colleagues accountable to a higher standard than short-term, quick-fix approaches. The whys help guide choices, focus effort, justify time spent, challenge strategies and tactics, and reinforce learning and change.")]), _vm._v(" "), _c('div', {
    staticClass: "chabox"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Good information and process—coupled with a strong understanding of why and how-to—makes for better decisions. The absence of these elements dramatically increases the likelihood of “what the hell am I gonna do now” moments.")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "tx1d"
  }, [_vm._v("—PARAPHRASING SHAWN POLAND, COHORT 15, MASTER’S PROGRAM, PHILANTHROPY AND DEVELOPMENT, SAINT MARY’S UNIVERSITY")])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("The evolution of the profession provides unique opportunities to apply the body of knowledge, expand research, and adapt technical expertise to diverse cultures around the world. But we must not ignore forgotten whys. Long-term significant fund development results depend on professionals and organizations that embrace both the whys and the how-tos. ")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "h7"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "end"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-en13",
      "id": "en13"
    }
  }, [_vm._v("1")]), _vm._v("   The term “organizational development” refers to all the elements of your organization, including governance, management, communications, and how it all fits together.")]), _c('div', {
    staticClass: "end"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-en14",
      "id": "en14"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('i', [_vm._v("Strategic Fund Development: Building Profitable Relationships That Last")]), _vm._v(" "), _c('i', [_vm._v("2")]), _c('sup', [_c('i', [_vm._v("nd")])]), _vm._v(" "), _c('i', [_vm._v("Ed")]), _vm._v(". (Sudbury, MA: Jones & Bartlett, 2001).")]), _c('div', {
    staticClass: "end"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-en15",
      "id": "en15"
    }
  }, [_vm._v("3")]), _vm._v("   Peter M. Senge, "), _c('i', [_vm._v("The Fifth Discipline")]), _vm._v(" (New York: Doubleday, 1990), p. 13.")]), _c('div', {
    staticClass: "end"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-en16",
      "id": "en16"
    }
  }, [_vm._v("4")]), _vm._v("   Cited in "), _c('i', [_vm._v("The Rolling Stone Book")]), _vm._v(" "), _c('i', [_vm._v("of Life: Wisdom for")]), _vm._v(" "), _c('i', [_vm._v("Survival")]), _vm._v(" (Philadelphia: Running Press, 1997), from original interview with Coppola in "), _c('i', [_vm._v("Rolling Stone")]), _vm._v(", February 7, 1991.")]), _c('div', {
    staticClass: "end"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-en17",
      "id": "en17"
    }
  }, [_vm._v("5")]), _vm._v("   Quoted in Linda Ellinor and Glenna Gerard, "), _c('i', [_vm._v("Dialogue: Rediscover the Transforming Power of Conversation")]), _vm._v(" (New York: John Wiley & Sons, 1998), p. 282.")]), _c('div', {
    staticClass: "end"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c05_r1#Ref-en18",
      "id": "en18"
    }
  }, [_vm._v("6")]), _vm._v("   Dick Whitney and Melissa Giovagnoli, "), _c('i', [_vm._v("75 Cage-Rattling Questions to Change the Way You Work")]), _vm._v(" (New York: McGraw-Hill, 1997), p. 75.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79224c86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aher_9781118044865_oeb_c05_r1.vue
// module id = 96
// module chunks = 0